export default {
  config: {
    script: {
      label: "编写脚本(待完善)",
      type: "codemirror", // 只需要在这里指定为 codemirror 即可
      attrs: {
        // 属性配置(会覆盖全局配置)
        options: {
          tabSize: 2,
          mode: "text/javascript",
          lineNumbers: true,
          line: true
        }
      }
    }
  },
  data: {}
};
